const {
  REACT_APP_PAPELZERO_ENDERECO,
  REACT_APP_HORUS_ENDERECO,
  REACT_APP_BUSINESS_INTELIGENCE_ENDERECO,
} = process.env;

interface AmbienteConfig {
  papelZeroEndereco: string;
  horusEndereco: string;
  businessInteligenceEndereco: string;
}

export const ambienteConfig: AmbienteConfig = {
  papelZeroEndereco: REACT_APP_PAPELZERO_ENDERECO || '',
  horusEndereco: REACT_APP_HORUS_ENDERECO || '',
  businessInteligenceEndereco: REACT_APP_BUSINESS_INTELIGENCE_ENDERECO || '',
};
